// "Agent updates" at the top of Installation > Sandbox hosts (installer
// ontwerp §1 step 8, §9.5): the automatic-update switch, the release this
// server offers, and what stops tunnel hosts from working at all.

import type { AgentPolicy } from '@goblic/shared'
import { Notice } from './ui'

export function AgentUpdateCard({
  policy,
  saving = false,
  onToggle,
}: {
  policy: AgentPolicy
  saving?: boolean
  onToggle: (autoUpdate: boolean) => void
}) {
  return (
    <section aria-label="Agent updates" className="panel space-y-3 p-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-base font-semibold text-ink">Agent updates</h2>
          <p className="text-sm text-ink-3">
            Current release on this server:{' '}
            <span className="font-mono text-ink-2">{policy.release?.version ?? 'none'}</span>
          </p>
        </div>
        <label className="flex items-center gap-2.5 text-base text-ink">
          <input
            type="checkbox"
            role="switch"
            checked={policy.autoUpdate}
            disabled={saving}
            onChange={(event) => onToggle(event.target.checked)}
            className="h-4 w-4 accent-[rgb(var(--moss))]"
          />
          Automatic updates
        </label>
      </div>
      {!policy.autoUpdate ? (
        <p className="text-sm text-ink-3">
          Updates are paused. Hosts keep their agent version until you choose Update agent now.
        </p>
      ) : null}
      {!policy.binariesAvailable ? (
        <Notice tone="signal">Agent binaries are not built on this server; see docs.</Notice>
      ) : null}
      {!policy.tunnelConfigured ? (
        <Notice tone="error">GOBLIC_EDGE_SECRET is not set; tunnel hosts cannot connect.</Notice>
      ) : null}
    </section>
  )
}
